import { formatNumber } from "../../../../../core/utils/common";
import {
    CMargin,
    DText,
    Flex,
    Row,
} from "../../../../../styles/CommonStyles";
import {
    TradeAmount,
    TradeTypeBadge,
} from "../../../../../styles/main/orders";
import Operation from "../../../../common/utils/Operation";
import UserLink from "../../../../common/utils/UserLink";
import DateTime from "../../../../common/utils/DateTime";
import { RespIndex } from "../../../../../styles/main/MainCommonStyles";
import RTableLayout from "../../../../responsive/layout/RTableLayout";
import { useNavigate } from "react-router-dom";


const RCardsTransferTable = ({ data }) => {

    const { data: transfers } = data;
    const navigate = useNavigate()



    return (
        <RTableLayout data={data}>

            {transfers?.data?.map((transfer, idx) => {

                const isIn = transfer.type === "in";

                return (
                    <Row
                        key={transfer._id}
                        index={idx}
                        cs="100%"
                    >

                        {/* Header */}

                        <Flex fw justify="space-between">

                            <UserLink
                                _id={transfer.userId}
                                name={transfer.user?.email}
                            />

                            <Operation
                                onDetailsClicked={() => navigate(`/reports/cards/transfer/${transfer._id}`)}
                                hasDetails
                            />

                        </Flex>

                        <CMargin margin="12px" />


                        {/* Currency */}

                        <Flex fw justify="space-between">

                            <DText main fontSize="s">
                                Currency
                            </DText>

                            <DText main fontSize="s">
                                {transfer.currency}
                            </DText>

                        </Flex>


                        {/* Type */}

                        <Flex fw justify="space-between">

                            <DText main fontSize="s">
                                Type
                            </DText>

                            <TradeTypeBadge
                                color={isIn ? "#10b981" : "#ef4444"}
                            >
                                {transfer.type}
                            </TradeTypeBadge>

                        </Flex>


                        {/* Amount */}

                        <Flex fw justify="space-between">

                            <DText main fontSize="s">
                                Amount
                            </DText>

                            <TradeAmount
                                type={isIn ? "buy" : "sell"}
                            >
                                {formatNumber(transfer.amount)}
                            </TradeAmount>

                        </Flex>


                        {/* Status */}

                        <Flex fw justify="space-between">

                            <DText main fontSize="s">
                                Status
                            </DText>

                            <TradeTypeBadge
                                color={
                                    transfer.status === "success"
                                        ? "success"
                                        : transfer.status === "pending"
                                            ? "warning"
                                            : "danger"
                                }
                            >
                                {transfer.status}
                            </TradeTypeBadge>

                        </Flex>


                        {/* Date */}

                        <Flex fw justify="space-between">

                            <DText main fontSize="s">
                                Date
                            </DText>

                            <DateTime dt={transfer.createdAt} />

                        </Flex>


                        <RespIndex>
                            {idx + 1}
                        </RespIndex>

                    </Row>
                );
            })}

        </RTableLayout>
    );
};

export default RCardsTransferTable;